module.exports = __webpack_public_path__ + "img/pg.227822c3.png";